import Vue from 'vue'
import Vuex from 'vuex'

import { authorMenu } from '@/common/'
import routerUrl from '@/common/routerUrl'
import { IS_PRODUCTION } from '@/common/variables'

Vue.use(Vuex)

export default new Vuex.Store<VuexState>({
  state: {
    keepSession: false,
    userData: null,
  },
  getters: {
    checkPermission(state) {
      return (currentMenu: string): boolean => {
        if (!state.userData) return false
        const menu = authorMenu(state.userData)
        return !currentMenu || menu.includes(currentMenu)
      }
    },
    isAdmin(state) {
      return state.userData?.authority === 'admin'
    },
  },
  mutations: {
    SET_USER(state, payload) {
      state.userData = payload
      state.keepSession = true
    },
    RESET_SESSION(state) {
      state.keepSession = false
    }
  },
  actions: {
    async getAccount({ state, commit }) {
      if (state.keepSession) return
      const { data, success } = await (await fetch('/user/overview')).json()
      commit('SET_USER', data || {})
      if (IS_PRODUCTION && window.collectEvent) {
        window.collectEvent('config', {
          user_unique_id: success && data ? data.userId : null
        })
      }
    }
  },
})
